import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import { useState } from "react";

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

// actions
import { loginUser } from "store/actions";

// Import scss
import "assets/custom/css/argon-dashboard.css?v=2.0.2";

const Login = (props) => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const { username, password } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    props.loginUser(formData, props.history);
  };

  return (
    <section>
      <div className="page-header2 min-vh-100">
        <MetaTags>
          <title>Carnesvilla | Login </title>
        </MetaTags>
        <div className="container2">
          <div className="row">
            <div className="col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0 mx-auto">
              <div className="card2 card2-plain">
                <div className="card2-header pb-0 text-start">
                  <h2 className="font-weight-bolder2">Bienvenido</h2>
                  <p className="text2-muted mb-0">
                    Ingresa tu usuario y contraseña para continuar
                  </p>
                </div>
                <div className="card2-body">
                  <form onSubmit={onSubmit}>
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form2-control form2-control-lg"
                        placeholder="Usuario"
                        aria-label="Text"
                        name="username"
                        value={username}
                        onChange={onChange}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="password"
                        className="form2-control form2-control-lg"
                        placeholder="Contraseña"
                        aria-label="Password"
                        name="password"
                        value={password}
                        onChange={onChange}
                        required
                      />
                    </div>
                    {props.error && typeof props.error.detail === "string" ? (
                      <div className="alert alert-danger">
                        {props.error.detail}
                      </div>
                    ) : null}
                    <div className="form2-check form2-switch">
                      <input
                        className="form2-check-input"
                        type="checkbox"
                        id="rememberMe"
                      />
                      <label className="form2-check-label" htmlFor="rememberMe">
                        Recuérdame
                      </label>
                    </div>

                    <div className="text-center">
                      {props.loading ? (
                        <div
                          className="spinner-border text-primary2"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        <button
                          type="submit"
                          className="btn2 btn2-lg btn2-primary btn2-lg w-100 mt-4 mb-0"
                        >
                          Ingresar
                        </button>
                      )}
                    </div>
                    <div className="text-muted2 text-center pt-4">
                      <i className="mdi mdi-lock me-1"></i> ¿Olvidaste la
                      contraseña?
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 end-0 text-center justify-content-center flex-column">
              <div
                className="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style={{
                  backgroundImage: `url("https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg")`,
                  backgroundSize: 'cover'
                }}
              >
                <span className="mask bg-gradient-primary opacity-6"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  const { error, loading } = state.Login;
  return { error, loading };
};

export default withRouter(connect(mapStateToProps, { loginUser })(Login));

Login.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  history: PropTypes.object,
  loginUser: PropTypes.func,
};
